import { ModuleType } from 'global-services/constants/OhsObject';

import OhsDocumentsListsRecord from './OhsDocumentsRecord';

export enum DocumentViewPreset {
  View1 = 'view_1',
  View2 = 'view_2',
  View3 = 'view_3',
  View4 = 'view_4',
}

export interface DocumentAllocatedListType extends OhsDocumentsListsRecord {
  _id: string;
  type: ModuleType;
  allocated: boolean;
  latestCompletedTask: string | null;
}

export interface OhsDocumentFilterPayload {
  archived?: boolean;
  skipOrgRecords?: boolean;
  viewPreset?: DocumentViewPreset;
  complete?: boolean;

  count: boolean;
  next?: string;
  page?: number;

  sort: {
    order: number;
    key: string;
  };
  categories?: string[];
  subcategories?: string[];
  workplaces?: string[];

  reviewScheduled?: boolean;
  allocatedToWorkplace?: boolean;
  notAllocated?: boolean;
  workplaceOwned?: boolean;
  copied?: boolean;
  copiedVersionUpdated?: boolean;
  notCopied?: boolean;
  dateIssued?: { start: string | null; end: string | null };
}

export interface OhsDocumentSearchFilter {
  archived?: boolean;
  skipOrgRecords?: boolean;

  count: boolean;
  page: number;
  next?: string;

  workplaces?: (string | null)[];
  categories?: string[];
  subcategories?: string[];
  dateIssued?: { start: string | null; end: string | null };
}

export interface OhsDocumentSearchMain {
  searchKey: string;
  substringSearch: boolean;
  highlight: boolean;
  filter: OhsDocumentSearchFilter;
  viewPreset: DocumentViewPreset;
  sort: {
    order: number;
    key?: string;
    relevance?: boolean;
  };
}
